import { PlaylistState } from "./types";

export const state: PlaylistState = {
  status: "",
  error: null,
  playlists: [],
  showCreatePlaylistDialog: false
};
